//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../Motion/Motion.EntityPropTableBuilder.js";
let d=[[[0,"Name",1,0]],[],[]];
SPLM.Motion.LinkDriverBuilder = class extends SPLM.Motion.EntityPropTableBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.LinkDriverBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.LinkDriverBuilder.CsysRotationType = Object.freeze({
    "Successive" : "Successive", "Fixed" : "Fixed"});

SPLM.Motion.LinkDriverBuilder.MeasureType = Object.freeze({
    "Displacement" : "Displacement", "Velocity" : "Velocity", "Acceleration" : "Acceleration"});

SPLM.Motion.LinkDriverBuilder.GlobalDirectionType = Object.freeze({
    "XDiff" : "XDiff", "YDiff" : "YDiff", "ZDiff" : "ZDiff", "Distance" : "Distance"});

export default SPLM;